import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const grid = css`
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: ${size[16]};
  overflow: visible;

  ${breakpoint.up('md')} {
    grid-gap: ${size[24]};
  }
`

export const headline = css`
  margin-bottom: ${size[16]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[24]};
  }
`
